import { api } from '../../client';

export interface JournalEntryDocumentDto {
  id: string;
  name: string;
  mimeType: string | null;
  size: number;
  createdAt?: string;
}

export const accountingJournalDocumentsApi = {
  async list(entryId: string): Promise<{ data?: JournalEntryDocumentDto[]; message?: string }> {
    return api.get(`/accounting/journals/${entryId}/documents`) as Promise<{ data: JournalEntryDocumentDto[] }>;
  },

  async upload(
    entryId: string,
    file: File
  ): Promise<{ data?: JournalEntryDocumentDto; message?: string; errors?: Record<string, string[]> }> {
    const formData = new FormData();
    formData.append('file', file);
    return api.upload(`/accounting/journals/${entryId}/documents`, formData) as Promise<{
      data: JournalEntryDocumentDto;
      message?: string;
    }>;
  },

  async download(documentId: string, fileName: string): Promise<void> {
    const token = localStorage.getItem('auth_token');
    const base = api.baseURL;
    const res = await fetch(`${base}/accounting/journals/documents/${documentId}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!res.ok) throw new Error('Download failed');
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName || 'document';
    a.click();
    URL.revokeObjectURL(url);
  },

  async delete(documentId: string): Promise<{ success?: boolean; message?: string }> {
    return api.delete(`/accounting/journals/documents/${documentId}`) as Promise<{
      success?: boolean;
      message?: string;
    }>;
  },
};
